module.exports = __webpack_public_path__ + "img/交通银行.43283454.png";